import React from 'react'
import { Typography, IconButton, Paper } from '@material-ui/core'
import { Edit as EditIcon } from '@material-ui/icons'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'

import images from './cardImages'

const styles = theme => ({
  paper: {
    padding: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  },
  row: {
    width: 600,
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between'
  },
  cardImage: {
    display: 'inline-block',
    width: 50
  },
  cardText: {
    margin: 'auto'
  }
})

const AddCreditCard = ({ classes, cardNumber, name, expiration }) => {
  const { t } = useTranslation()

  // determining card type by the first digit
  const firstDigit = cardNumber.charAt(0)
  const type = firstDigit === '3' ? 'amex'
    : firstDigit === '4' ? 'visa'
      : firstDigit === '5' ? 'mastercard'
        : 'placeholder'

  return (
    <Paper className={classes.paper}>
      <div className={classes.row}>

        {/* small SVG with the icon of the card type, i.e. Visa, MasterCard */}
        <img src={images[type]} className={classes.cardImage} alt={t('Cabinet:credit card icon')}/>

        {/* 4 last digits of the card number */}
        <Typography variant='h6' className={classes.cardText}>{`•••• ${cardNumber.slice(-4)}`}</Typography>

        {/* cardholder's name */}
        <Typography variant='h6' className={classes.cardText}>{name}</Typography>

        {/* expiration */}
        <Typography variant='h6' className={classes.cardText}>{expiration}</Typography>

        {/* edit button */}
        <IconButton aria-label={t('Cabinet:delete card')} size='small'>
          <EditIcon />
        </IconButton>

      </div>
    </Paper>
  )
}

export default withStyles(styles)(AddCreditCard)
